module.exports = __webpack_public_path__ + "media/images/people/people-2a9307d1ec0313c6735bb98283f366cc.webp";